import { render, staticRenderFns } from "./step-navigation.vue?vue&type=template&id=4bc7a788&scoped=true"
import script from "./step-navigation.vue?vue&type=script&lang=js"
export * from "./step-navigation.vue?vue&type=script&lang=js"
import style0 from "./step-navigation.vue?vue&type=style&index=0&id=4bc7a788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7a788",
  null
  
)

export default component.exports